import { Link } from "react-router-dom";
import type { ModuleI } from "../../../types";

interface Props {
  topic: ModuleI;
  topicHref: string;
}

export default function ToolboxHeader({ topic, topicHref }: Props) {
  return (
    <div className="flex flex-col gap-2 mb-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <img
            src={topic.icon.src}
            alt={topic.icon.alt || topic.title}
            className="w-8 h-8 object-contain"
          />
          <h1 className="text-2xl font-bold text-gray-800">
            {topic.title} Toolbox
          </h1>
        </div>
        <Link
          to={topicHref}
          className="text-sm font-medium text-electrum-300 hover:text-electrum transition-colors whitespace-nowrap hidden md:block"
        >
          Learn more about {topic.title}
        </Link>
      </div>
      {topic.subtitle && (
        <p className="text-sm text-gray-600 md:mb-0">{topic.subtitle}</p>
      )}
      <Link
        to={topicHref}
        className="text-sm font-medium text-electrum-300 hover:text-electrum transition-colors whitespace-nowrap md:hidden w-fit"
      >
        Learn more about {topic.title}
      </Link>
    </div>
  );
}
